import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export default class DeepSeekAIQuestionListAPI extends BasicsClass {
  public apiUrls: any = new Map([
    ['getDeepseekAIQuestionManageList', {
      url: '/admin/deepseek/question/list',
      name: 'list',
      label: '列表'
    }],
    ['addDeepseekAIQuestionManage', {
      url: '/admin/deepseek/question/add',
      name: 'add-ai-question',
      label: '添加AI问题'
    }],
    ['updateDeepseekAIQuestionManage', {
      url: '/admin/deepseek/question/update',
      name: 'edit-ai-question',
      label: '编辑AI问题'
    }],
    // ['deleteDeepseekAIQuestionManage', {
    //   url: '/admin/coachLeader/del',
    //   name: 'delete-leader',
    //   label: '删除AI问题'
    // }],
  
   
  ])

  // AI问题列表
  public getDeepseekAIQuestionManageList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getDeepseekAIQuestionManageList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 修改AI问题
  public updateDeepseekAIQuestionManage(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('updateDeepseekAIQuestionManage').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 添加AI问题
  public addDeepseekAIQuestionManage(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('addDeepseekAIQuestionManage').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 删除AI问题
  // public deleteDeepseekAIQuestionManage(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('deleteDeepseekAIQuestionManage').url

  //   this.BasicPost(url, {
  //     ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }

  
}